/* eslint @typescript-eslint/default-param-last: 0 */
import styled from '@emotion/styled';
import setMargin from '../../helpers/set-margin';

export const decideBackgroundBasic = ({
  variant,
  disabled,
  theme,
}) => {
  if (disabled) {
    return `${theme.colors.neutral.shades.shade300}`;
  } else {
    switch (variant) {
      case 'primary':
        return `${theme.colors.primary.main}`;
      case 'secondary':
        return `${theme.colors.secondary.main}`;
      case 'blue':
        return `${theme.colors.blue.main}`;
      default:
        return `${theme.colors.primary.main}`;
    }
  }
};

export const decideBackgroundActive = ({
  variant,
  theme,
  disabled
}) => {
  if (disabled) {
    return `${theme.colors.neutral.shade300}`;
  } else {
    switch (variant) {
      case 'primary':
        return `${theme.colors.primary.shades.shade700}`;
      case 'secondary':
        return `${theme.colors.secondary.shades.shade600}`;
      case 'blue':
        return `${theme.colors.blue.shades.shade600}`;
      default:
        return `${theme.colors.blue.shades.shade600}`;
    }
  }
};

export const decideBackgroundHover = (
  variant = 'primary',
  theme,
  disabled
) => {
  if (disabled) {
    return `${theme.colors.neutral.shade300}`;
  } else {
    switch (variant) {
      case 'primary':
        return `${theme.colors.primary.shades.shade800}`;
      case 'secondary':
        return `${theme.colors.secondary.shades.shade700}`;
      case 'blue':
        return `${theme.colors.blue.shades.shade700}`;
      default:
        return `${theme.colors.blue.shades.shade700}`;
    }
  }
};

export const decidePaddingX = ({ size }: { size: string }) => {
  switch (size) {
    case 'regular':
      return `24px`;
    case 'medium':
      return `20px`;
    case 'small':
      return `16px`;
    default:
      return `24px`;
  }
};

export const decideHeight = ({ size }: { size: string }) => {
  switch (size) {
    case 'regular':
      return `48px`;
    case 'medium':
      return `40px`;
    case 'small':
      return `32px`;
    default:
      return `48px`;
  }
};

export const BasicButton = styled('button')`
  ${setMargin};
  height: ${({ size }) => decideHeight({ size })};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center !important;
  width: ${({ width }) => width || '100% !important'};
  color: ${({ theme, variant }) => variant === 'blue' ? 'rgb(23, 17, 39)' : theme.colors.white};
  position: relative;
  background: ${({ variant, theme, disabled }) =>
    decideBackgroundBasic({ variant, theme, disabled })};
  border: none;
  border-radius: ${({ borderRadius }) => borderRadius || '8px'};
  font-size: 1rem;
  letter-spacing: 0.04rem;
  padding: ${({ size }) => decidePaddingX({ size })};
  box-shadow: ${({ theme }) => theme.shadows[0]};
  transition:
    background-color 300ms linear,
    color 300ms linear;

  /* clicking style */
  :active {
    color: ${({ variant, theme, disabled }) =>
    decideBackgroundActive({ variant, theme, disabled })}
  }

  :hover {
    background: ${({ variant, theme, disabled }) =>
    decideBackgroundHover(variant, theme, disabled)};
  }

  :focus {
    box-shadow: 0px 0px 0px 2px #B2F2F9;
    border-radius: 4px;
  }

  :focus-visible {
    outline: none;
  }

  /* for disabled style */
  opacity: ${({ disabled, loading }) => (disabled || loading ? 0.5 : 1)};

  cursor: ${({ disabled, loading }) =>
    disabled || loading ? 'not-allowed' : 'pointer'};
`;

export const InnerTextAlign = styled.span`
  padding-top: 0px;
  line-height: ${(icon) => icon && 'normal'}
`;
